import type { Habit, HabitTimeSlot } from '../db/models'

/** Sort key for the flat list: morning → noon → evening → anytime. */
export const TIME_SLOT_ORDER: Record<HabitTimeSlot | 'anytime', number> = {
  morning: 0,
  noon: 1,
  evening: 2,
  anytime: 3,
}

/** A habit's time-of-day slot, or 'anytime' for every non-`timeOfDay` frequency. */
export function habitTimeSlot(habit: Pick<Habit, 'frequency'>): HabitTimeSlot | 'anytime' {
  return habit.frequency.kind === 'timeOfDay' ? habit.frequency.slot : 'anytime'
}
